import FunnelFooter from './FunnelFooter'

export default FunnelFooter
